<script setup>
defineProps({
  year: { type: Number, default: () => new Date().getFullYear() },
  sitemapHref: { type: String, default: '' },
  legalLinks: { type: Array, default: () => [] },
  creditsHref: { type: String, default: 'https://www.admix.nl' },
  creditsLabel: { type: String, default: 'Admix' },
  copyrightBrand: { type: String, default: 'VSB Verhuur' }
});

function onPrivacyClick(event) {
  if (typeof window !== 'undefined' && window.mcb && typeof window.mcb.show === 'function') {
    event.preventDefault();
    window.mcb.show();
  }
}
</script>

<template>
  <div class="vsb-footer__bottom">
    <div class="content-container">
      <div class="vsb-footer__bottom-content">
        <div class="vsb-footer__copyright">
          &copy; {{ year }} {{ copyrightBrand }} – Alle rechten voorbehouden
        </div>
        <div class="vsb-footer__links-bottom">
          <template v-for="(link, index) in legalLinks" :key="link.href">
            <span v-if="index > 0" class="vsb-footer__separator">•</span>
            <a
              v-if="link.privacy"
              href="#"
              @click="onPrivacyClick"
            >{{ link.label }}</a>
            <a v-else :href="link.href">{{ link.label }}</a>
          </template>
        </div>
        <div class="vsb-footer__credits">
          Website door
          <a :href="creditsHref" target="_blank" rel="noopener noreferrer" class="vsb-footer__admix-link">
            {{ creditsLabel }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
